<mat-icon class="ara-panel__icon" [svgIcon]="iconPath()"></mat-icon>
<div class="ara-panel__message">
	@if (headerText()) {
		<span class="ara-panel__header">{{ headerText() }}</span>
	}
	@if (message()) {
		{{ message() }}
	} @else {
		<ng-content />
	}
</div>
